import React from "react";
import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="relative z-10 border-t border-[#14140f]/10 bg-[#fdfdfb]" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 py-8 flex flex-col md:flex-row items-center justify-between gap-5">
      <span className="text-sm text-[#14140f]/50 order-2 md:order-1">
        © {new Date().getFullYear()} Living Wisdom Explorer
      </span>
      <nav className="flex items-center gap-6 text-sm order-1 md:order-2">
        <Link to="/" className="text-[#14140f]/60 hover:text-[#14140f] transition-colors duration-200" data-testid="footer-home-link">
          Home
        </Link>
        <Link to="/explore" className="text-[#14140f]/60 hover:text-[#14140f] transition-colors duration-200" data-testid="footer-explore-link">
          Explore
        </Link>
        <Link to="/privacy" className="text-[#c23c28] font-medium hover:underline" data-testid="footer-privacy-link">
          Privacy
        </Link>
      </nav>
    </div>
  </footer>
);

export default Footer;
